import { render } from "./ThemeImagesSettings.vue?vue&type=template&id=670a9ab4&scoped=true"
import script from "./ThemeImagesSettings.vue?vue&type=script&lang=js"
export * from "./ThemeImagesSettings.vue?vue&type=script&lang=js"

import "./ThemeImagesSettings.vue?vue&type=style&index=0&id=670a9ab4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670a9ab4"]])

export default __exports__